import { render, staticRenderFns } from "./item3.vue?vue&type=template&id=48571927&scoped=true"
import script from "./item3.vue?vue&type=script&lang=js"
export * from "./item3.vue?vue&type=script&lang=js"
import style0 from "./item3.vue?vue&type=style&index=0&id=48571927&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48571927",
  null
  
)

export default component.exports